import { render, staticRenderFns } from "./modifyPriceDialog.vue?vue&type=template&id=193cb7dd"
import script from "./modifyPriceDialog.vue?vue&type=script&lang=js"
export * from "./modifyPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports